export const ACTIONS = {
    GET_MMV_DATA: 'GET_MMV_DATA',
    SET_MMV_DATA: 'SET_MMV_DATA',
};
